import { MeasureUnitName } from '../../../utils/index'
import moment from 'moment'
import store from '../../../store.js'
import { getSaleTemplate } from './saleTmpl'
import { getGiftTemplate } from './giftTmpl'
import { getTransTemplate } from './transTmpl'

export function getTemplateList(rows) {
  const printTemplates = []
  rows.forEach(item => {
    const {
      type,
      orderSource,
      createTime,
      code,
      bizOrderCode,
      customerName,
      orderRemark,
      auditStaffName,
      createName,
      sourceWarehouseNo,
      destWarehouseNo,
      warehouseNo,
      ownerName,
      detailList,
      saleStaffName,
      saleDepartmentName,
      storekeeperStaffName: warehouseSatff
    } = item
    const skuList = []
    let total = 0
    detailList.forEach(i => {
      const { skuCode, skuName, skuSpec, num, measureUnit } = i
      const unit = MeasureUnitName.find(i => i.value === measureUnit) || {}
      total += num
      skuList.push({
        skuCode,
        skuName,
        skuSpec,
        num,
        measureUnit: unit.label || ''
      })
    })
    const createTimeName = moment(createTime).format('YYYY/MM/DD')
    const sourceWarehouseName = (store.state.account.warehouse.find(i => i.warehouseNo === sourceWarehouseNo) || {}).warehouseName
    const destWarehouseName = (store.state.account.warehouse.find(i => i.warehouseNo === destWarehouseNo) || {}).warehouseName
    const warehouseName = (store.state.account.warehouse.find(i => i.warehouseNo === warehouseNo) || {}).warehouseName
    let printTemplate = ''
    if (type === 21) { // 销售出库
      if (orderSource === 7) { // 礼品
        printTemplate = getGiftTemplate({
          ownerName,
          createTimeName,
          warehouseName,
          code,
          bizOrderCode,
          customerName,
          skuList,
          orderRemark,
          auditStaffName,
          createName,
          orderType: '礼品其他出库单',
          warehouseSatff,
          total,
          saleStaffName,
          saleDepartmentName
        })
      } else { // 其他
        printTemplate = getSaleTemplate({
          ownerName,
          createTimeName,
          warehouseName,
          code,
          bizOrderCode,
          customerName,
          skuList,
          orderRemark,
          auditStaffName,
          createName,
          financeName: '蔡冰',
          warehouseSatff,
          total
        })
      }
    }

    if (type === 23) { // 调拨出库
      printTemplate = getTransTemplate({
        ownerName,
        createTimeName,
        sourceWarehouseName,
        destWarehouseName,
        code,
        bizOrderCode,
        customerName,
        skuList,
        orderRemark,
        auditStaffName,
        createName,
        financeName: '蔡冰',
        warehouseSatff,
        total,
        saleStaffName
      })
    }
    printTemplates.push({
      printTemplate
    })
  })
  return printTemplates
}
